import ProfileView from "@/components/ProfileView";
export default function MyPassion() {
  return <ProfileView />;
}
